import {StoreType} from '../../../types/sharedTypes';


export const orderParamsSelector = (state: StoreType) => {
  return state.orderReducer.orderParams;
}

export const orderDetailSelector = (state: StoreType) => {
  return state.orderReducer.orderDetail;
}

export const allOrdersSelector = (state: StoreType) => {
  return state.orderReducer.ordersResult;
}
